import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
@Component({
  selector: 'app-microsoft-itfacilitygrid',
  templateUrl: './microsoft-itfacilitygrid.component.html',
  styleUrls: ['./microsoft-itfacilitygrid.component.scss']
})
export class MicrosoftItfacilitygridComponent implements OnInit {

  public Microsoft360editdata:any={};
  constructor(public appservice:AppService,public location:Location,public router:Router) { }
 get_Microsoft360_ITfacilitygrid(){
  this.appservice.getTable("api/Transaction/getMicrosoft360_ITfacilitygrid").subscribe((res:any)=>{
    this.Microsoft360editdata=JSON.parse(res).record;
  
  });
 }

  editEmployee(id:any){
    //this.appservice.get_Microsoft360_ITfacilityeditdata(id);
    this.appservice.Microsoft360editid=id;
    console.log("the edit id",this.appservice.Microsoft360editid)
    this.router.navigateByUrl('/home/microsoft-itfacilityform');
  }
  
  ngOnInit(): void {
    this.appservice.get_Microsoft360_ITfacilitygrid();
  }

}
